module.exports = __webpack_public_path__ + "img/7200.7a76de97.jpg";